<template>
    <app-page-content>
        <app-title text="Módulo de Logistica" />
        <router-view></router-view>
    </app-page-content>
</template>
<script>
    import Title from '../UI/Layout/Title.vue';
    import PageContent from '../UI/Layout/PageContent.vue';
    export default {
        components: {
            appPageContent: PageContent,
            appTitle: Title
        }
    }
</script>